module.exports = __webpack_public_path__ + "img/43193f3.svg";